export const appendUrlSearchParams = ({
  url,
  searchParams,
}: {
  url: URL;
  searchParams: Record<string, string>;
}) => {
  Object.entries(searchParams).forEach(([key, value]) => {
    url.searchParams.append(key, value);
  });
};
